import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { PROMO_TYPE_HERO, PROMO_MARKETING_PERKS, getPromoData } from 'helpers/SeriesDetailHelpers';
import style from './NationWhatIs.css';

const NationWhatIs = ({ isFreeTrialPlanActive, promos = [] }) => {
  const promoData = getPromoData({ data: promos, promoType: PROMO_MARKETING_PERKS });
  const content = promoData?.items?.member ?? [];
  const heroContent = _.find(content, { promoType: PROMO_TYPE_HERO });
  const heroDeviceImage = _.get(heroContent, 'images.undefined', '');
  const deviceImageBackgroundStyle = { backgroundImage: `url(${heroDeviceImage})` };

  const filteredContent = content.filter(item => {
    if (!isFreeTrialPlanActive) {
      return !item?.headline?.includes('Get Started Free');
    }
    return true;
  });

  return (
    <div className={style.container}>
      <div className={style.anonMiddleLeft}>
        <img
          src="/static/images/nation-logo-230x70.png"
          className={style.logo}
          alt="Fox Nation logo"
        />
        <div className={style.devices} style={deviceImageBackgroundStyle} />
      </div>
      <div className={style.anonMiddleRight}>
        <ul>
          {filteredContent.map((item, index) => {
            if (item.promoType !== PROMO_TYPE_HERO) {
              return (
                <li key={item.headline}>
                  {index === 1 ? <h2>{item.headline}</h2> : <h3>{item.headline}</h3>}
                  {item.description && <p>{item.description}</p>}
                </li>
              );
            }
            return null;
          })}
        </ul>
      </div>
    </div>
  );
};

NationWhatIs.propTypes = {
  isFreeTrialPlanActive: PropTypes.bool,
  promos: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default NationWhatIs;
